import request from './api'

export class ReviewService {
    async validateRoom(fixtureRoomId: string) {
        const response = await request({
            method: 'POST',
            url: `api/review/${fixtureRoomId}/validate`
        });

        return response;
    }

    async getReviewDetails(fixtureRoomId: string) {
        const response = await request({
            method: 'GET',
            url: `api/review/${fixtureRoomId}/reviewdetails`
        });

        return response;
    }

    async getReviewInputList(fixtureRoomId: string) {
        const response = await request({
            method: 'GET',
            url: `api/review/${fixtureRoomId}/inputlist`
        });

        return response;
    }

    async getSupremacyChart(fixtureRoomId: string) {
        const response = await request({
            method: 'GET',
            url: `api/review/${fixtureRoomId}/supremacychart`
        });

        return response;
    }

    async getBreakdown(fixtureRoomId: string) {
        const response = await request({
            method: 'GET',
            url: `api/review/${fixtureRoomId}/breakdown`
        });

        return response;
    }

    async getReviewClipOverview(fixtureRoomId: string) {
        const response = await request({
            method: 'GET',
            url: `api/review/${fixtureRoomId}/clipoverview`
        });
        return response;
    }


    async setClipReviewed(clipId: string, isReviewed: string) {
        const response = await request({
            method: 'POST',
            url: `api/review/${clipId}/setclipreviewed`,
            data: {isReviewed}
        });

        return response;
    }

    async setClipNoteReviewed(clipId: string, notes: string) {
        const response = await request({
            method: 'POST',
            url: `api/review/${clipId}/setclipnote`,
            data: {notes}
        });

        return response;
    }

    static get instance() {
        return reviewService
    }
}

const reviewService = new ReviewService();

export default reviewService;